"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useLocale_1 = require("../../../hooks/useLocale/useLocale");
const Styled = __importStar(require("./RowTagItem.styles"));
const RowTagItem = ({ tag, isIndividualPermissionTag = false, testId }) => {
    const { formatMessage } = (0, useLocale_1.useLocale)();
    const tagText = {
        NIEZDEFINIOWANO: 'permissions.notDefined',
        BRAK: 'permissions.noRights',
        PRZYZNANO: 'permissions.granted',
        BRAK_INDYWIDUALNE: 'permissions.noRights',
        PRZYZNANO_INDYWIDUALNE: 'permissions.granted',
        PERSONALNA: 'groups.groupType.personal',
        STRUKTURALNA: 'groups.groupType.structural',
        ADMINISTRATOR: 'user.type.admin',
        ZWYKLY: 'user.type.ordinary',
    };
    // Bulletproof validation to prevent FormatJS errors
    const getSafeDisplayValue = () => {
        try {
            // Input validation
            if (!tag || typeof tag !== 'string') {
                console.warn(`[RowTagItem] Invalid tag value:`, tag);
                return 'UNKNOWN';
            }
            // Check if tag is in our known mapping
            const messageId = tagText[tag];
            // Triple validation for FormatJS safety
            if (messageId && typeof messageId === 'string' && messageId.trim().length > 0) {
                try {
                    // Attempt to format the message
                    const formattedMessage = formatMessage({ id: messageId });
                    // Verify the result is valid
                    if (typeof formattedMessage === 'string' && formattedMessage.trim().length > 0) {
                        return formattedMessage;
                    }
                    else {
                        console.warn(`[RowTagItem] FormatMessage returned invalid result for messageId "${messageId}":`, formattedMessage);
                        return tag;
                    }
                }
                catch (formatError) {
                    console.warn(`[RowTagItem] FormatMessage failed for messageId "${messageId}":`, formatError);
                    return tag;
                }
            }
            // Fallback to raw tag with corruption detection
            if (tag.includes('STRUKTURALNA') && tag !== 'STRUKTURALNA') {
                console.warn(`[RowTagItem] Detected corrupted STRUKTURALNA enum:`, tag);
                return 'STRUKTURALNA'; // Sanitize corrupted structural group type
            }
            if (tag.includes('PERSONALNA') && tag !== 'PERSONALNA') {
                console.warn(`[RowTagItem] Detected corrupted PERSONALNA enum:`, tag);
                return 'PERSONALNA'; // Sanitize corrupted personal group type
            }
            // Log unknown values for debugging
            if (!Object.keys(tagText).includes(tag)) {
                console.warn(`[RowTagItem] Unknown tag value received:`, tag);
            }
            return tag;
        }
        catch (error) {
            console.error(`[RowTagItem] Critical error in getSafeDisplayValue:`, error);
            return 'ERROR';
        }
    };
    const safeDisplayValue = getSafeDisplayValue();
    return ((0, jsx_runtime_1.jsx)(Styled.RowItem, { children: (0, jsx_runtime_1.jsx)(Styled.TagItem, { "data-testid": testId, "$tag": tag, "$isIndividualPermissionTag": isIndividualPermissionTag, children: safeDisplayValue }) }));
};
// eslint-disable-next-line import/no-default-export
exports.default = RowTagItem;
